export default __webpack_public_path__ + "static/media/circleBg.869b77f0.png";